'use client'

import styled, { css } from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  border-top: 1px solid ${o => o.theme.color.fill.subtle};
  line-height: 18px;
  padding: ${o => o.theme.spacing(5, 0, 3, 0)};

  &:first-of-type {
    border-top-width: 0;
  }
`

export const Items = styled.div<{ $isOnlyOneItem: boolean }>`
  position: relative;

  ${({ $isOnlyOneItem, theme }) =>
    !$isOnlyOneItem &&
    css`
      padding-left: ${theme.spacing(5)};

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: ${theme.spacing(4)};
        bottom: ${theme.spacing(3)};
        width: 4px;
        background: ${theme.color.fill.disabled.subtle};
      }
    `}
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${o => o.theme.spacing(2)};
`

export const DiscountDisplayText = styled(TypeStyle.BodyNano)<{ $isDiscountApplied: boolean }>`
  color: ${({ $isDiscountApplied, theme }) =>
    $isDiscountApplied ? 'inherit' : theme.color.stroke.info.text.on.background};
  font-weight: 500;
`
